// A position can be offered as a batch ("erä"). Its real quantities (e.g. m² or pieces) are
// then entered in the batch calculation review of the primary version.
const BATCH_UNIT = 'consignment';

interface IQuantityPosition {
  quantity: number | null;
  unit: string;
  versions: {
    isPrimary: boolean;
    calculationReviews?: {
      quantity: number | null;
      quantityUnit: string | null;
    }[];
  }[];
}

/**
 * Sums the quantities of the given positions by unit, e.g. { m2: 120.5, amount: 14 }.
 * Batch positions are counted by the quantities of their batch calculation review; a
 * batch without a review is counted as one batch.
 */
const getOfferQuantities = (
  positions: IQuantityPosition[]
): { [unit: string]: number } => {
  const quantities: { [unit: string]: number } = {};

  const add = (unit: string | null, quantity: number | null) => {
    if (unit === null || unit === '' || quantity === null) {
      return;
    }

    const value = Number(quantity);
    if (!Number.isFinite(value)) {
      return;
    }

    quantities[unit] = (quantities[unit] ?? 0) + value;
  };

  positions.forEach((position) => {
    if (position.unit !== BATCH_UNIT) {
      add(position.unit, position.quantity);
      return;
    }

    const primaryVersion = position.versions.find(
      (version) => version.isPrimary
    );
    const reviews = (primaryVersion?.calculationReviews ?? []).filter(
      (review) => review.quantity !== null && review.quantityUnit !== null
    );

    if (reviews.length === 0) {
      add(BATCH_UNIT, position.quantity ?? 1);
      return;
    }

    // The reviewed quantities are the totals of the whole position, like in the batch
    // calculation review where the position totals are divided by them
    reviews.forEach((review) => add(review.quantityUnit, review.quantity));
  });

  return quantities;
};

export default getOfferQuantities;
